export default __webpack_public_path__ + "static/media/de.67ea3e1e.svg";